import { reactive } from 'vue'
import { loginCommonConfig } from './common'
import type { LoginPageConfig } from './types'

export const theme = {
  facebookBlue: '#1A77F2',
  googleBlue: '#239FFB',
  appleDark: '#282828',
  inputBorder: '#FCD58A',
} as const

export const resources = {
  loginBg: '/images/aurenovel/login/login-bg.webp',
  logo: '',
  novel: '',
  facebookIcon: '/images/aurenovel/login/icon-facebook-logo.png',
  googleIcon: '/images/aurenovel/login/icon-google-logo.png',
  appleIcon: '/images/aurenovel/login/icon-apple-logo.png',
  emailIcon: '/images/aurenovel/login/icon-email.png',
  emailCodeIcon: '/images/aurenovel/login/icon-email-code.png',
} as const

export const loginConfig: LoginPageConfig = {
  theme,
  resources,
  texts: reactive(loginCommonConfig.texts),
}
